module.exports = __webpack_public_path__ + "img/details.e2ecb2c4.svg";